<div class="card ">
  <div class="card-header container-fluid">
    <div class="btn-group-sm">
      <button
        mat-mini-fab
        type="button"
        class="me-2 shadow-none"
        [ngClass]="{'disabled': pageNumber === 1}"
        (click)="pageNumber = pageNumber - 1"
        [disabled]="pageNumber === 1"
        aria-label="Previous Page"
        title=" Previous Page">
        <i class="fa fa-caret-left fs-5"></i>
      </button>
      <button
        mat-mini-fab
        type="button"
        class="me-2 shadow-none"
        [ngClass]="{'disabled': pageNumber === (numberOfPages)}"
        (click)="pageNumber = pageNumber + 1"
        [disabled]="(pageNumber === (numberOfPages)) || !numberOfPages"
        title="next Page">
        <i class="fa fa-caret-right fs-5"></i>
      </button>
      <button
        mat-mini-fab
        type="button"
        class="me-2 shadow-none"
        (click)="zoomLevel = zoomLevel + .1"
        title="zoom in">
        <i class="fa fa-search-plus fs-5"></i>
      </button>
      <button
        mat-mini-fab
        type="button"
        class="me-2 shadow-none"
        (click)="zoomLevel = zoomLevel - .1"
        title="zoom out">
        <i class="fa fa-search-minus fs-5"></i>
      </button>
      <button
        mat-mini-fab
        type="button"
        class="me-2 shadow-none"
        (click)="download()"
        title="download">
        <i class="fa fa-download fs-5"></i>
      </button>
      <div class="pull-right mt-3">
        <span class="me-2 fw-bold ">{{ filePreviewTitle }}</span>
        <span>Page {{pageNumber}} of {{numberOfPages}}</span>
      </div>
    </div>
  </div>
  <div class="card-body ">
    <pdf-viewer #pdfViewer1 [src]="src"
      [render-text]="true"
      [original-size]="false"
      [show-all]="false"
      [page]="pageNumber"
      [zoom]="zoomLevel"
      (after-load-complete)="pdfRendered($event)"
      [ngStyle]="{
                  width: (_width) ? _width : '100%',
                  height: (_height) ? _height : '600px',
                  }"
      (mousemove)="onDrag($event, pdfViewer1)"
      (mousedown)="onDragStarted()"
      (mouseup)="onDragEnded()"
      (mouseleave)="onDragEnded()">
    </pdf-viewer>
  </div>
</div>